import { Icon } from '@iconify/react';
import clsx from 'clsx';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useOutsideClick } from '../../hooks/useOutsideClick';

export function ThreadMenu({ handleBookmarkButton, isBookmarked = false }) {
  const [clickOutside, setClickOutside] = useState(true);
  const handleClickOutside = () => setClickOutside(true);
  const ref = useOutsideClick(handleClickOutside);
  const handleMenuClick = () => {
    setClickOutside(false);
  };

  return (
    <>
      <button
        aria-label="thread menu"
        onClick={handleMenuClick}
        onKeyDown={(e) => {
          if (e.code === 'Escape') setClickOutside(true);
        }}
        className={clsx('relative inline-block py-2 opacity-30', [
          !clickOutside && 'opacity-0',
        ])}
      >
        <Icon icon="ph:dots-three-outline-vertical-fill" />
      </button>
      {!clickOutside && (
        <div
          onKeyDown={(e) => {
            if (e.code === 'Escape') setClickOutside(true);
          }}
          className="relative right-0 z-40"
        >
          <ul
            ref={ref}
            className="dark:highlight-gray-50/5 absolute top-6 right-0 overflow-hidden whitespace-nowrap rounded-lg bg-gray-50 py-1 text-sm text-gray-700 shadow-lg ring-1 ring-gray-900/10 dark:bg-gray-800 dark:text-gray-300 dark:ring-0"
          >
            <li className="flex cursor-pointer items-center p-1">
              <button
                aria-label="bookmark button"
                onClick={async () => {
                  await handleBookmarkButton();
                  setClickOutside(true);
                }}
                className="inline-flex w-full items-center px-3 py-2 text-left hover:bg-indigo-500/5 dark:hover:bg-indigo-500/5"
              >
                {isBookmarked ? (
                  <>
                    <span className="mr-1">
                      <Icon
                        icon="material-symbols:bookmark-remove-rounded"
                        className="h-4 w-4"
                      />
                    </span>
                    Unsave thread
                  </>
                ) : (
                  <>
                    <span className="mr-1">
                      <Icon
                        icon="material-symbols:bookmark-add-rounded"
                        className="h-4 w-4"
                      />
                    </span>
                    Save thread
                  </>
                )}
              </button>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

ThreadMenu.propTypes = {
  handleBookmarkButton: PropTypes.func.isRequired,
  isBookmarked: PropTypes.bool,
};
